module.exports = __webpack_public_path__ + "img/basic_bar_elonged.76bd36be.png";